import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Switch } from "abs-ui-components";

import Voyage from "./Voyage/Voyage";
import BDN from "./BDN/BDN";
import CIIData from "./CIIData/CIIData";
import ReportSubmission from "./ReportSubmission/ReportSubmission";
import { REPORTED_DATA } from "../../../constants/ReportedDataMenus_constants";
import BDNSummary from "../child-reports/DCSReport/DCSReportedData/BDNSummary/BDNSummary";
import IMODCSData from "../child-reports/DCSReport/DCSReportedData/IMODCSData/IMODCSData";
import CIIGraph from "../child-reports/DCSReport/DCSReportedData/CIIGraph/CIIGraph";
import EUMRVVoyages from "../child-reports/EUMRVReport/EUMRVReportedData/EUMRVVoyages/EUMRVVoyages";
import EUMRVPortStays from "../child-reports/EUMRVReport/EUMRVReportedData/EUMRVPortStays/EUMRVPortStays";
import EUMRVReportSummary from "../child-reports/EUMRVReport/EUMRVReportedData/EUMRVReportSummary/EUMRVReportSummary";
import UKMRVVoyages from "../child-reports/UKMRVReport/UKMRVReportedData/UKMRVVoyages/UKMRVVoyages";
import UKMRVPortStays from "../child-reports/UKMRVReport/UKMRVReportedData/UKMRVPortStays/UKMRVPortStays";
import UKMRVReportSummary from "../child-reports/UKMRVReport/UKMRVReportedData/UKMRVReportSummary/UKMRVReportSummary";
import { useParams } from "react-router";
import MergedDcsReportSummary from "../child-reports/DCSReport/DCSReportedData/DCSReportSummary/DCSReportSummary-merge";
import FEUMRVEnergyMonitoring from "../child-reports/FEUMRVReport/FEUMRVReportedData/FEUMRVEnergyMonitoring/FEUMRVEnergyMonitoring";
import FEUMRVFEUContribution from "../child-reports/FEUMRVReport/FEUMRVReportedData/FEUMRVFEUContribution/FEUMRVFEUContribution";
import FEUReportSummary from "../child-reports/FEUMRVReport/FEUMRVReportedData/FEUReportSummary/FEUReportSummary";
import UKETSVoyages from "../child-reports/UKETS/UKETSReport/UKETSReportedData/UKETSVoyages/UKETSVoyages";
import UKETSPortStays from "../child-reports/UKETS/UKETSReport/UKETSReportedData/UKETSPortStays/UKETSPortStays";
import UKETSReportSummary from "../child-reports/UKETS/UKETSReport/UKETSReportedData/UKETSReportSummary/UKETSReportSummary";

const ReportData = (props) => {

	const params = useParams();
	const reportMstId = params.id;
	const reportDetails = useSelector(
		(state) => state?.reports?.selectedReportDetails
	);

	let initialLinks = [];
	if (reportDetails?.IsParentReport) {
		initialLinks = REPORTED_DATA.PARENT_REPORT_LINKS;
	} else {
		switch (reportDetails?.Regulations?.trim()) {
			case "DCS":
				initialLinks = REPORTED_DATA.DCS_LINKS;
				break;
			case "EUMRV":
				initialLinks = REPORTED_DATA.EUMRV_LINKS;
				break;
			case "UKMRV":
				initialLinks = REPORTED_DATA.UKMRV_LINKS;
				break;
			case "FEU":
				initialLinks = REPORTED_DATA.FEUMRV_LINKS;
				break;
			case "UKETS":
				initialLinks = REPORTED_DATA.UKETS_LINKS;
				break;
			default:
				initialLinks = [];
		}
	}

	const [selectedLink, setSelectedLink] = useState(initialLinks[0] || null);
	const [links, setLinks] = useState(initialLinks);

	useEffect(() => {
		if (props?.activeTab === 1) {
			props?.handleSubTabChange(selectedLink);
		} else {
			props?.handleSubTabChange("");
		}
	}, [props?.activeTab]);

	useEffect(() => {
		let newLinks = [];
		if (reportDetails?.IsParentReport) {
			newLinks = REPORTED_DATA.PARENT_REPORT_LINKS;
		} else {
			switch (reportDetails?.Regulations?.trim()) {
				case "DCS":
					newLinks = REPORTED_DATA.DCS_LINKS;
					break;
				case "EUMRV":
					newLinks = REPORTED_DATA.EUMRV_LINKS;
					break;
				case "UKMRV":
					newLinks = REPORTED_DATA.UKMRV_LINKS;
					break;
				case "FEU":
					newLinks = REPORTED_DATA.FEUMRV_LINKS;
					break;
				case "UKETS":
					newLinks = REPORTED_DATA.UKETS_LINKS;
					break;
				default:
					newLinks = [];
			}
		}
		setLinks(newLinks);
		setSelectedLink(newLinks[0] || null);
	}, [reportDetails]);

	const linkChangeHandler = (e) => {
		setSelectedLink(e);
		props?.handleSubTabChange(e);
		
	};

	return (
		<>
			<Switch
				links={links}
				selected={selectedLink}
				onChange={linkChangeHandler}
			/>
			{/* Parent Report Tab menus */}
			{selectedLink === "VOYAGE" && <Voyage showData={props.showData} />}
			{selectedLink === "BDN" && <BDN showData={props.showData} />}
			{selectedLink === "CII DATA" && <CIIData />}
			{selectedLink === "REPORT SUBMISSION" && <ReportSubmission />}

			{/* DCS Child Report Tab menus */}
			{selectedLink === "BDN SUMMARY" && <BDNSummary />}
			{selectedLink === "IMO DCS DATA" && <IMODCSData />}
			{selectedLink === "CARBON INTENSITY INDICATOR (CII)" && (
				<CIIGraph ChildReportMstId={reportDetails?.ReportMstId} />
			)}
			{selectedLink === "REPORT SUMMARY" &&
				reportDetails?.Regulations?.trim() === "DCS" && (
					<MergedDcsReportSummary />
				)}

			{/* EUMRV Child Report Tab menus */}
			{selectedLink === "EU MRV VOYAGES" && <EUMRVVoyages />}
			{selectedLink === "EU MRV PORT STAYS" && <EUMRVPortStays />}
			{selectedLink === "REPORT SUMMARY" &&
				reportDetails?.Regulations?.trim() === "EUMRV" && (
					<EUMRVReportSummary />
				)}

			{/* UKMRV Child Report Tab menus */}
			{selectedLink === "UK MRV VOYAGES" && <UKMRVVoyages />}
			{selectedLink === "UK MRV PORT STAYS" && <UKMRVPortStays />}
			{selectedLink === "REPORT SUMMARY" &&
				reportDetails?.Regulations?.trim() === "UKMRV" && (
					<UKMRVReportSummary />
				)}

			{/* FEUMRV Child Report Tab menus */}
			{selectedLink === "ENERGY MONITORING" && <FEUMRVEnergyMonitoring />}
			{selectedLink === "FEU CONTRIBUTION" && 
			<FEUMRVFEUContribution 
			 isReportEnabled={props?.isReportEnabled}
			/>}
			{selectedLink === "REPORT SUMMARY" &&
				reportDetails?.Regulations?.trim() === "FEU" && (
					<FEUReportSummary />
				)}
			{/* UKETS Child Report Tab menus */}
			{selectedLink === "UK ETS VOYAGES" && <UKETSVoyages />}
			{selectedLink === "UK ETS IN-PORT ACTIVITIES" && <UKETSPortStays />}
			{selectedLink === "REPORT SUMMARY" &&
				reportDetails?.Regulations?.trim() === "UKETS" && (
					<UKETSReportSummary />
			)}
		</>
	);
};

export default ReportData;
